module.exports = __webpack_public_path__ + "static/media/travel.81e37e14.svg";